module.exports = __webpack_public_path__ + "static/Get_Ready_to_Code-19bca4d1976f17933c8e9e29e5c95844.png";